import { Component, Input, ViewEncapsulation } from '@angular/core';
import { JuiSvgIcon, JUI_INPUT_IMPORTS, JUI_TEXTAREA_IMPORTS } from '@jump-tech-frontend/core-components-angular';
import { FormPresenter } from '../form/form.presenter';
import { FormViewModel } from '../form/form.view.model';
import { ReactiveFormsModule } from '@angular/forms';

// todo see if we can get better paths for styles?

@Component({
  selector: 'help-component',
  templateUrl: './help.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './help.component.scss',
    '../../../../../../question-components/src/lib/sass/relay.scss',
    '../../../../../../cards/src/lib/sass/relay.scss'
  ],
  imports: [JuiSvgIcon, ...JUI_INPUT_IMPORTS, ...JUI_TEXTAREA_IMPORTS, ReactiveFormsModule],
  providers: [FormPresenter]
})
export class HelpComponent {
  @Input() vm: FormViewModel;
  constructor(private formPresenter: FormPresenter) {}
}
